import { FC } from 'react';
import styled from 'styled-components';

import Text from '@/components/Text';
import { FreelancerWageResource } from '@/types/resources';
import { renderCurrencySign } from '@/utils/helpers';

const Heading = styled(Text)`
  margin-bottom: 6px;
  span {
    text-transform: capitalize;
  }
`;

const StyledText = styled(Text)`
  line-height: 22px;
`;

const Wages = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 12px;
  gap: 16px;
`;

const WageBullet = styled(Text)`
  background: ${({ theme }) => theme.colors.grayscaleLight};
  border-radius: 100px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  span {
    color: ${({ theme }) => theme.colors.gray};
    margin-left: 2px;
  }
`;

interface Props {
  type: 'hour' | 'day' | 'month' | 'job' | 'other';
  wages?: FreelancerWageResource[];
}

const FreelancerWageType: FC<Props> = ({ type, wages }) => {
  // The backend sends wages newest first.
  const currentWage = wages?.find((wage) => wage.type === type);

  const renderWageType = () => {
    switch (type) {
      case 'hour':
        return 'Hour';
      case 'day':
        return 'Day';
      case 'month':
        return 'Month';
      case 'job':
        return 'Single Job';
      case 'other':
        return 'Other';
    }
  };

  return (
    <div>
      <Heading $type="smallHeadline" $color="gray">
        Current {renderWageType()} Wage
      </Heading>
      {currentWage ? (
        <Wages>
          <WageBullet $type="smallHeadline">
            {type === 'other' ? currentWage.text_amount : currentWage.amount}
            {currentWage.currency && renderCurrencySign(currentWage.currency)}
          </WageBullet>
        </Wages>
      ) : (
        <StyledText $type="captionSemibold">-</StyledText>
      )}
    </div>
  );
};

export default FreelancerWageType;
